<template>
<portal to="snackbar-destination">
  <transition name="fade">
    <div class="snackbar" :class="{'snackbar--success': success, 'snackbar--error': error }">
      <svg class="snackbar__badge snackbar__badge--error" width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.3" cx="44" cy="44" r="44" fill="#F67D88"/>
        <circle cx="43.9999" cy="44.0004" r="35.619" fill="#F67D88"/>
        <path d="M44.0006 52.3566C43.402 52.3566 42.8865 52.141 42.4541 51.7099C42.055 51.2787 41.8056 50.65 41.7058 49.8236L39.5108 30.9611C39.4776 30.7815 39.4609 30.53 39.4609 30.2066C39.4609 28.8773 39.8933 27.8174 40.758 27.027C41.6227 26.2365 42.7036 25.8413 44.0006 25.8413C45.2977 25.8413 46.3785 26.2365 47.2432 27.027C48.108 27.8174 48.5403 28.8952 48.5403 30.2605C48.5403 30.5839 48.5237 30.8354 48.4904 31.015L46.2455 49.8236C46.179 50.65 45.9296 51.2787 45.4972 51.7099C45.0981 52.141 44.5993 52.3566 44.0006 52.3566ZM44.0006 64.4286C42.7701 64.4286 41.7557 63.9975 40.9575 63.1352C40.1594 62.237 39.7603 61.1232 39.7603 59.7938C39.7603 58.4645 40.1594 57.3686 40.9575 56.5064C41.7557 55.6081 42.7701 55.159 44.0006 55.159C45.2312 55.159 46.2455 55.6081 47.0437 56.5064C47.8419 57.3686 48.241 58.4645 48.241 59.7938C48.241 61.1232 47.8419 62.237 47.0437 63.1352C46.2455 63.9975 45.2312 64.4286 44.0006 64.4286Z" fill="white"/>
      </svg>
      <svg class="snackbar__badge snackbar__badge--success" width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.3" cx="44" cy="44" r="44" fill="#4C91FF"/>
        <circle cx="43.9999" cy="44.0004" r="35.619" fill="#4C91FF"/>
        <path d="M28.7535 43.9999C29.6399 43.1134 31.0771 43.1134 31.9635 43.9999L41.5936 53.63C39.8208 55.4028 36.9464 55.4028 35.1735 53.63L28.7535 47.2099C27.867 46.3235 27.867 44.8863 28.7535 43.9999Z" fill="white"/>
        <path d="M38.3836 50.4199L56.0388 32.7647C56.9252 31.8783 58.3624 31.8783 59.2488 32.7647C60.1353 33.6511 60.1353 35.0883 59.2488 35.9747L41.5936 53.63L38.3836 50.4199Z" fill="white"/>
        <path d="M41.5936 53.63L31.9635 43.9999C31.0771 43.1134 29.6399 43.1134 28.7535 43.9999V43.9999C27.867 44.8863 27.867 46.3235 28.7535 47.2099L35.1735 53.63C36.9464 55.4028 39.8208 55.4028 41.5936 53.63V53.63ZM41.5936 53.63L59.2488 35.9747C60.1353 35.0883 60.1353 33.6511 59.2488 32.7647V32.7647C58.3624 31.8783 56.9252 31.8783 56.0388 32.7647L38.3836 50.4199L41.5936 53.63Z" stroke="white" stroke-width="6.28571"/>
      </svg>
      <span class="snackbar__message" v-html="message"></span>
      <svg class="snackbar__close" @click="$emit('close')" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.785 0.604971C25.4113 0.230466 24.904 0.02 24.375 0.02C23.846 0.02 23.3387 0.230466 22.965 0.604971L13.185 10.365L3.405 0.584971C3.03134 0.210466 2.52404 0 1.995 0C1.46596 0 0.958663 0.210466 0.585 0.584971C-0.195 1.36497 -0.195 2.62497 0.585 3.40497L10.365 13.185L0.585 22.965C-0.195 23.745 -0.195 25.005 0.585 25.785C1.365 26.565 2.625 26.565 3.405 25.785L13.185 16.005L22.965 25.785C23.745 26.565 25.005 26.565 25.785 25.785C26.565 25.005 26.565 23.745 25.785 22.965L16.005 13.185L25.785 3.40497C26.545 2.64497 26.545 1.36497 25.785 0.604971Z" fill="black" fill-opacity="0.54"/>
      </svg>
    </div>
  </transition>
</portal>
</template>

<script>
export default {
  name: 'snackbar',
  props: {
    message: String,
    success: Boolean,
    error: Boolean
  },
  created() {
    const self = this
    if (self.success) {
      setTimeout(function() {
        self.$emit('close')
      }, 5000)
    }
  }
}
</script>

<style lang="scss" scoped>
.snackbar {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1400px;

  position: fixed;
  top: 64px;
  height: 70px;
  z-index: 9;

  background: #F7F7F7;
  padding-left: 20px;
  box-sizing: border-box;
  box-shadow: 0 4px 4px rgba(109, 109, 109, 0.1);

  &__badge {
    display: none;
    width: 48px;
  }

  &__message {
    font-family: Nunito;
    font-style: normal;
    font-weight: 900;
    font-size: 16px;
    line-height: 20px;
    padding-left: 10px;
  }

  &__close {
    position: absolute;
    right: 30px;
    width: 16px;
    cursor: pointer;
  }

  &--error {
    border-left: solid 4px #F67D88;
    .snackbar__message {
      color: #F67D88;
    }
    .snackbar__badge--error {
      display: block;
    }
  }
  &--success {
    border-left: solid 4px #4C91FF;
    .snackbar__message {
      color: #4C91FF;
    }
    .snackbar__badge--success {
      display: block;
    }
  }
}
@media screen and (min-width: 641px) {
  .snackbar {
    height: 86px;

    &__badge {
      width: 60px;
    }

    &__message {
      font-size: 20px;
      line-height: 24px;
      padding-left: 15px;
    }

    &__close {
      width: 20px;
    }

    &--error {
      border-left: solid 6px #F67D88;
    }
    &--success {
      border-left: solid 6px #4C91FF;
    }
  }
}
@media screen and (min-width: 769px) {
  .snackbar {
    height: 110px;

    &__badge {
      width: 72px;
    }

    &__message {
      font-size: 24px;
      line-height: 30px;
      padding-left: 15px;
    }

    &__close {
      width: 24px;
    }

    &--error {
      border-left: solid 6px #F67D88;
    }
    &--success {
      border-left: solid 6px #4C91FF;
    }
  }
}
</style>
